import React from 'react';
import { useHistory } from 'react-router-dom';
import InterpretationList from '../../components/InterpretationList';

import { Container, Card } from './styles';

const Interpretation = () => {
    const history = useHistory();

    return (
        <InterpretationList/>

    );
}

export default Interpretation;
